

















































import _isFinite from 'lodash/isFinite'
import { PropType } from '@vue/composition-api'
import { directive as onClickaway } from 'vue-clickaway2'
import FormText from '@/components/Forms/FormText.vue'
import { SemesterNames, SemesterName, SemesterNameIndex } from '@shared/sm/general/semesterNames/types'

export default {
  components: { FormText },
  directives: { onClickaway },
  props: {
    semesterNames: {
      type: Object as PropType<SemesterNames>,
      default: () => ({}),
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({ editing: false }),
  methods: {
    addSemesterName () {
      const indexes = Object.keys(this.semesterNames)
      const lastIndex = parseInt(indexes[indexes.length - 1])
      // `semesterNames` starts with key of 1, not 0, hence why `+ 1`
      const nextIndex = _isFinite(lastIndex)
        ? lastIndex + 1
        : 1
      this.$emit('input', { ...this.semesterNames, [nextIndex]: '' })
    },
    updateSemesterName (semesterName: SemesterName, index: SemesterNameIndex) {
      this.$emit('input', { ...this.semesterNames, [index]: semesterName })
    },
    deleteSemesterName (index: SemesterNameIndex) {
      const { [index]: deleted, ...woDeleted } = this.semesterNames
      this.$emit('input', woDeleted)
    },
    setEditing (editing: boolean) {
      if (!this.editable) return
      this.editing = editing
    },
  },
}
